import { Box } from "@mui/material";
import React from "react";

import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";

interface props {
  visible: boolean;
  children: false | JSX.Element | JSX.Element[];
}

export default function PopoverBox({ visible, children }: props) {
  const maximizeTable = sidebarStore((state) => state.maximizeTable);
  const showDescription = sidebarStore((state) => state.showDescription);
  const topicPopover = sidebarStore((state) => state.topicPopover);
  const axisControlPopover = sidebarStore((state) => state.axisControlPopover);
  const editPopover = sidebarStore((state) => state.editPopover);
  const measurementPopover = sidebarStore((state) => state.measurementPopover);

  const showAxisscale = defaultStore((state) => state.showAxisscale);
  const authMode = defaultStore((state) => state.authMode);

  const width = "444px";
  const widthExpanded = "800px";
  const height =
    authMode === "edit" ? (showAxisscale ? "476px" : "428px") : "428px";
  const heightExpanded = "100%";

  const toolbarToolsFullHeight =
    maximizeTable ||
    (showDescription && measurementPopover) ||
    topicPopover ||
    axisControlPopover ||
    editPopover;

  return (
    <Box
      id="popover-box"
      sx={{
        width: maximizeTable
          ? { xs: width, md: widthExpanded, lg: "1100px" }
          : width,
        height: visible
          ? toolbarToolsFullHeight
            ? heightExpanded
            : height
          : "0px",
        top: "-8px",
        left: visible ? "0" : "-1108px",
        position: "absolute",
        overflow: "hidden",
        zIndex: -1,
        paddingRight: 1,
        paddingY: 1,
        backgroundColor: "whiteBackground.main",
        backdropFilter: "blur(10px)",
        borderRadius: "0px 10px 10px 0px",
        transition: "left 0.3s ,  height 0.3s , width 0.3s, padding 0.3s",
      }}
    >
      <Box
        sx={{
          marginLeft: "72px",
          height: "100%",
        }}
      >
        {visible && children}
      </Box>
    </Box>
  );
}
